<template>
  <h3>处理中...请稍后</h3>
</template>
<script>
import { setStorage, getStorage, goBack, removeStorage } from "@/libs/utils";
import { getWechatCode } from "@/libs/wechat";
import { registerpayorder } from "@/libs/api";
import { Dialog } from "vant";

export default {
  data() {
    return {};
  },
  mounted() {
    this.$nextTick(() => {
      let payto = getStorage("pay");
      if (payto) {
        removeStorage("pay");
        goBack("index");
        return;
      }
      if (!this.$route.query.code) {
        var payparams = this.$route.params;
        var payurl = this.$route.params.payurl;
        setStorage("payparams", payparams, true);
        if (payurl) setStorage("payurl", payurl, true);
        getWechatCode("snsapi_base");
      } else {
        var payparams = getStorage("payparams");
        var url =
          window.location.protocol +
          "//" +
          window.location.hostname +
          ":" +
          window.location.port +
          "/myregister";
        var payurl = payparams.free ? url : getStorage("payurl");
        payparams.code = this.$route.query.code;
        registerpayorder(payparams).then(res => {
          if (res.status == 200) {
            let pay = "pay";
            setStorage("pay", pay, true);
            if (res.data.paystate == 1) {
              // console.log(payurl);
              window.location.replace(payurl);
            } else {
              let replace = "again";
              setStorage("replace", replace, true);
              let shipment = res.data.shipment;
              shipment.jumpurl = encodeURIComponent(payurl);
              delete shipment.mweb_url;
              let jumpurl =
                "https://store.moveclub.cn/wechatpaynew.php?info=" +
                encodeURIComponent(JSON.stringify(shipment));
              window.location.replace(jumpurl);
            }
          } else {
            Dialog.confirm({
              title: "提示",
              message: res.message
            })
              .then(() => {
                // on close
                if (payurl) {
                  window.location.replace(payurl);
                } else {
                  this.$router.replace({ name: "myregister" });
                }
              })
              .catch(() => {
                goBack();
              });
            //处理非200

            //
          }
        });
      }
    });
  }
};
</script>
